import { setUserSession } from "../../redux/slices/user/userSlice";
import { useAppDispatch } from "../../redux/hooks";
import { ISession } from "../../components/types/user";



export const useUserActions = () => {
  const dispatch = useAppDispatch();

  const setSession = (session : ISession) => {
    dispatch(setUserSession(session));
  }

  return { setSession };
}




